<template>
    <div id="page">

        <div class="page-content">
            <div class="page-title page-title-small">
                <h2><button @click.prevent="goBack"><i class="fa fa-arrow-right"></i></button>اشخاص و موسسات</h2>
                <button class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center refresh-btn" @click.prevent="reloadPage"><i class="font-16 fa fa-redo"></i></button>
            </div>
            <div class="card header-card shape-rounded" data-card-height="150">
                <div class="card-overlay bg-highlight opacity-95"></div>
                <div class="card-overlay dark-mode-tint"></div>
                <div class="card-bg bg-20"></div>
            </div>

            <div class="card card-style mb-2 p-3">
                <div class="search-box search-color bg-magenta1-light rounded-sm w-100">
                    <i class="fa fa-search"></i>
                    <input type="text" class="border-0" placeholder="جستجو ..." data-search="" v-model="searchKey" @change="filterList">
                </div>
            </div>
            <div class="card card-style mb-2" v-for="task in PersonList" :key="task.personId">
                <div class="list-group list-custom-small list-icon-0">
                    <router-link :to="{ name: 'EditPerson', params: { personId: task.personId  } }" href="#" class="list-group-div p-2">
                        <div class="d-flex justify-content-between">
                            <div>
                                <i class="fa fa-hashtag color-blue2-dark"></i>
                                <span class="text-muted">{{task.code}}</span>
                            </div>                                
                            <span class="font-weight-lighter text-muted">{{task.personGroupTitle}}</span>
                        </div>
                        <div>
                            <i class="fa fa-check color-red1-dark"></i>
                            <span class="font-weight-bold">{{task.title}}</span>
                        </div>
                        <div>
                        </div>
                    </router-link>
                </div>
            </div>
            <div class="card card-style" v-if="Loading==false && NoMoreData==false && PersonList.length>0">
                <div class="content">
                    <div class="d-flex justify-content-center w-100">
                        <button class="btn btn-outline-info" @click="getNextPageForPersonList">نمایش بیشتر</button>
                    </div>
                </div>
            </div>
            <div class="card card-style" v-if="Loading">
                <div class="content">
                    <div class="d-flex justify-content-center w-100 py-5">
                        <div class="spinner-border color-magenta2-dark" role="status"></div>
                    </div>
                </div>
            </div>
        </div>
        <transition enter-active-class="animated bounceInUp" leave-active-class="animated bounceOutDown">
            <div v-show="pageLoaded==true" class="addBtn" id="addBtn" ref="addBtn" :style="{top:addButtonTop}">
                <router-link to="/CreatePerson" class="btn px-3 py-2  rounded-xl bg-green2-light font-900 text-white shadow-xl border-green2-dark">
                    <i class="fa fa-plus font-14"></i>
                </router-link>
            </div>
        </transition>
       
        <div id="menu-language" class="menu menu-box-bottom menu-box-detached rounded-m" data-menu-effect="menu-over" style="display: block;">
            <div class="m-3">
                <div class="list-group list-custom-small">
                    <router-link :to="{ name: 'EditPerson', params: { personId: selectedWorkId  } }" class="d-flex justify-content-between align-items-center"><span><i class="fa fa-search color-green2-light float-right font-14"></i>مشاهده</span><i class="fa fa-angle-left"></i></router-link>
                    <a href="#" @click="deletePerson" class="d-flex justify-content-between align-items-center"><span><i class="fa fa-trash color-red1-light float-right font-14"></i>حذف</span><i class="fa fa-angle-left"></i></a>

                </div>
                <div class="clear"></div>
            </div>
        </div>

    </div>



</template>

<script>
import VueSimpleAlert from "vue3-simple-alert";
    export default {
        data() {
            return {
                page: 1,
                searchKey: "",
                selectedWorkId: 0,
                pageLoaded: false
            };
        },
        computed: {
            PersonList() {
                return this.$store.getters.GetPersonList;
            },
            Loading() {
                return this.$store.getters.GetLoading;
            },
            NoMoreData() {
                return this.$store.getters.GetPersonNoMoreData;
            }
        },

        created() {
            console.log(this.NoMoreData);

            this.$store.dispatch("GetPersonListFromServerForIndex", {
                pageId: this.page,
                text: this.searchKey
            });
        },
        methods: {
            showAddButton() {
                this.pageLoaded = true;
                
            },
            showMenu(personId) {
                this.selectedWorkId = personId
            },
          
            deletePerson() {
               VueSimpleAlert.confirm("آیا مایل به حذف این فعالیت هستید؟", null, "question", { confirmButtonText: "تایید", cancelButtonText: "انصراف" }).then(() => {
                    this.$http.get("Person/Delete?id=" + this.selectedWorkId)
                        .then(data => {
                            var res = data.data;
                            if (res.includes("حذف شد")) {
                                this.showSuccessMessage("با موفقیت حذف شد.");
                                this.$router.go();

                            }
                            else {
                                this.showErrorMessage(res);
                            }


                        });
                });
            },
            openDetails(personId) {
                this.$router.push({ name: 'EditPerson', params: { personId: personId } });
                document.getElementsByClassName('menu-hider')[0].click();
            },
            getNextPageForPersonList() {

                this.page++;
                console.log(this.page);
                this.$store.dispatch("GetPersonListFromServerForIndex", {
                    pageId: this.page,
                    text: this.searchKey
                });
            },
            filterList() {
                this.page = 1;
                this.$store.dispatch("GetPersonListFromServerForIndex", {
                    pageId: this.page,
                    text: this.searchKey
                });
            },
        },
        mounted() {
            console.log("mounted");
            this.showAddButton();
            // this.getNextPageForPersonList();


        }
    };
</script>
